import { Modal } from "@msuite/ui/modal";
import { useQuery } from "@msuite/ui/query";
import { DataTable } from "@msuite/ui/table";
import { responseHandler } from "@msuite/ui/utils";
import { guardArray } from "@msuite/utils/array";
import { client } from "@/hono";
import { AutoIntegrationContext, AutoIntegrationMenu, enableRowSelection } from ".";
import { columns } from "./table-config";

/** Props Interface */
interface AutoIntegrationProps {
	integrationType: "webfleet";
	onComplete: () => Promise<unknown>;
}

export function AutoIntegration({ integrationType, onComplete }: AutoIntegrationProps) {
	/** Hooks */

	/** Query */
	const {
		data: list,
		refetch,
		isLoading,
		queryKey,
	} = useQuery({
		queryKey: [integrationType, "auto-integration"],
		queryFn: async () => {
			const response = await client.integrations[integrationType]["auto-integration"].$get();
			const data = await responseHandler(response);
			return data.list;
		},
	});

	/** Render */
	return (
		<AutoIntegrationContext.Provider value={{ autoIntegrationList: guardArray(list as any) }}>
			<Modal.TableWrapper>
				<DataTable
					data={guardArray(list as any)}
					columns={columns as any}
					isLoading={isLoading}
					refetch={refetch}
					menu={
						<AutoIntegrationMenu
							integrationType={integrationType}
							onComplete={onComplete}
						/>
					}
					queryKey={queryKey}
					persistenceKey={`${integrationType}-auto-integration-table`}
					enableRowSelection={enableRowSelection}
					enableMultiRowSelection
				/>
			</Modal.TableWrapper>
		</AutoIntegrationContext.Provider>
	);
}
